import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import { LanguageContext } from '../../../contexts/LanguageContext';
import '../css/AboutPage.css';
import aboutImage from '../../../assets/images/AboutUs.png';

const AboutUsPage = () => {
  const { t } = useContext(LanguageContext);

  return (
    <motion.section
      className="aboutus-section"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: false, amount: 0.3 }}
      transition={{ duration: 0.8 }}
    >
      <div className="aboutus-container">
        <div className="aboutus-text">
          <span className="section-kicker">{t('about')}</span>
          <motion.h2
            className="section-title about-title"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 0.6 }}
          >
            {t('aboutUsTitle')}
          </motion.h2>

          <motion.p
            className="aboutus-paragraph"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            {t('aboutUsText')}
          </motion.p>
        </div>

        <div className="aboutus-image">
          <motion.img
            src={aboutImage}
            alt={t('aboutUsAlt') || 'About Vatti Taverna'}
            initial={{ opacity: 0, scale: 0.92 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          />
        </div>
      </div>
    </motion.section>
  );
};

export default AboutUsPage;
